import { Box, Stack } from '@mui/material';
import { HomeIconLabel } from './HomeIconLabel';
import { Survey, SurveyList } from '@xolv-mybrightlink/mybrightlink';

type SurveySectionProps = {
  surveys: Survey[];
};

export const SurveySection = ({ surveys }: SurveySectionProps) => {
  return (
    <Box mt={10}>
      <Stack direction='row' justifyContent='start' alignItems='center'>
        <HomeIconLabel
          labelKey='home.label.survey'
          src='/public/assets/icons/ic_survey.svg'
          labelSxProps={{ fontSize: '1.25rem' }}
        />
      </Stack>
      <SurveyList surveys={surveys} />
    </Box>
  );
};
